import React, { useRef, useCallback } from "react";
import { ReactLenis } from "lenis/react";
import { ScrollContext } from "./scroll";
import Header from "./Header";
import Hero from "./Hero";
import Ribbon from "./Ribbon";
import IndustrySelector from "./IndustrySelector";
import ModuleSection from "./ModuleSection";
import UnifiedPlatform from "./UnifiedPlatform";
import WhyAjmus from "./WhyAjmus";
import ProcessSection from "./ProcessSection";
import RoleExperience from "./RoleExperience";
import Capabilities from "./Capabilities";
import DemoCTA from "./DemoCTA";
import FAQSection from "./FAQSection";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import DemoBookingModal from "./DemoBookingModal";
import { HEALTHCARE_MODULES, EDUCATION_MODULES } from "../../data/content";

const HEALTH_ACCENT = { color: "#0D9488", soft: "#06B6D4" };
const EDU_ACCENT = { color: "#4F46E5", soft: "#7C3AED" };

export default function LandingPage() {
  const lenisRef = useRef(null);

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const lenis = lenisRef.current?.lenis;
    if (lenis) {
      lenis.scrollTo(el, { offset: -72, duration: 1.1 });
    } else {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, []);

  return (
    <ReactLenis root ref={lenisRef} options={{ lerp: 0.09, smoothWheel: true }}>
      <ScrollContext.Provider value={{ scrollToId }}>
        <div className="min-h-screen bg-[#FAFAFA]">
          <Header />
          <main>
            <Hero />
            <Ribbon />
            <IndustrySelector />
            <ModuleSection
              id="healthcare"
              chapter="01"
              overline="Healthcare Management"
              title="Complete Healthcare Management Ecosystem"
              description="Connect patient care, clinical workflows, billing, inventory, diagnostics, pharmacy, workforce management and reporting in one integrated system."
              modules={HEALTHCARE_MODULES}
              accent={HEALTH_ACCENT}
              tint="#FFFFFF"
            />
            <ModuleSection
              id="education"
              chapter="02"
              overline="School & Education Management"
              title="Everything Your Educational Institution Needs"
              description="Manage admissions, academics, fees, communication, staff, examinations, transport and institutional operations from one connected platform."
              modules={EDUCATION_MODULES}
              accent={EDU_ACCENT}
              tint="#FAFAFA"
            />
            <UnifiedPlatform />
            <WhyAjmus />
            <ProcessSection />
            <RoleExperience />
            <Capabilities />
            <DemoCTA />
            <FAQSection />
          </main>
          <Footer />
          <WhatsAppFloat />
          <DemoBookingModal />
        </div>
      </ScrollContext.Provider>
    </ReactLenis>
  );
}
